import {questionProps} from './question.props'

import * as Types from './types'
import {successGenerate} from '../common'
const INIT_STATE: questionProps = {
  questions:[],
  lastRequestDate:null
}

const questionReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.STORY_QUESTION_GROUP):
      return {
        ...state,
        questions: payload.data,
      }
    default:
      return state
  }
}

export {questionReducer}
